import React, {useRef} from 'react';
import Box from "../Common/Box";
import Pets from "@mui/icons-material/Pets";
import {Chip, SxProps} from "@mui/material";
import Face from "@mui/icons-material/Face";
import {User} from "../lib/stores/UserStore";
import uiStore from "../lib/stores/uiStore";
import {action} from "mobx";
import {useTheme} from "@mui/material/styles";

const styles = {
    avatarContainer: {
        position: "relative",
        paddingRight: "6px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    avatar: {
        width: "48px",
        height: "48px",
        borderRadius: "24px",
        boxShadow:
                "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2)"

    },
    mini: {
        width: "24px",
        height: "24px",
        borderRadius: "12px",
    },
};

interface UserProps {
    user: User,
    owner: boolean,
    mini?: boolean,
    sx?: SxProps,
}

function UserUi({
                    user,
                    owner,
                    mini,
                    sx = {
                        padding: "5px 5px 0 14px",
                        overflow: "hidden",
                    }
                }: UserProps) {

    const theme = useTheme();
    const ref = useRef();

    const {
        avatar_url,
        username,
        bot
    } = user;

    return (
            <Box
                    forwardedRef={ref}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "5px",
                        cursor: "pointer",
                        ...sx,
                    }}
                    onClick={action(function (event) {
                        uiStore.userInfoView = {
                            userInfoPlacement: "left-start",
                            selectedUser: user,
                            userAnchorEl: ref,
                        }
                        event.stopPropagation();
                        uiStore.userInfoVisible = true;
                    })}
                    // onContextMenu={onUserClick}
                    overflow={"hidden"}
            >
                <Box>
                    <Box sx={styles.avatarContainer}>
                        <img
                                crossOrigin={"anonymous"}
                                style={{
                                    ...styles.avatar,
                                    ...mini && styles.mini,
                                }}
                                src={avatar_url} alt={'avatar'}
                        />
                    </Box>

                </Box>
                <Box row alignItems={"center"} flex={1} paddingLeft={"4px"} overflow={"hidden"}>
                    <Box overflow={"hidden"} textOverflow={"ellipsis"}>
                        {username}
                    </Box>
                    {bot && <Chip
                            sx={{
                                marginLeft: "10px",
                                '& .MuiChip-label': {
                                    marginTop: '2px' // Adjust this value as needed
                                }
                            }}
                            size="small"
                            color="primary"
                            variant="outlined"
                            icon={<Face/>}
                            label="AI"
                    />
                    }
                    {owner && <Pets
                            sx={{
                                // color: theme.palette.primary.main,
                                marginBottom: "2px",
                                marginLeft: "4px",
                            }}
                    />}
                </Box>
            </Box>
    );
}


export default UserUi;
